export default __webpack_public_path__ + "static/nomster@2x-4823cd362ae28b28590ce26075a3d355.png";